import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const BandTypeGaleries = () => {
  return (
    <div className="hidden lg:block w-full">
      <div className="hidden lg:flex flex-row justify-between space-x-1 pt-20">
        <StaticImage
          className="w-1/5"
          src="../../static/images/band-type/band-type-2.png"
          alt="band-type-2"
        />
        <StaticImage
          className="w-1/5"
          src="../../static/images/band-type/band-type-3.png"
          alt="band-type-3"
        />
        <StaticImage
          className="w-1/5"
          src="../../static/images/band-type/band-type-4.png"
          alt="band-type-4"
        />
        <StaticImage
          className="w-1/5"
          src="../../static/images/band-type/band-type-5.png"
          alt="band-type-5"
        />
        <StaticImage
          className="w-1/5"
          src="../../static/images/band-type/band-type-6.png"
          alt="band-type-6"
        />
      </div>
      <div className="max-w-screen-2xl mx-7 2xl:mx-auto border-b mt-20"></div>
    </div>
  )
}

export default BandTypeGaleries
